<template>
  <div ref="mapChart" style="width: 100%; height: 300px"></div>
</template>

<script>
import { GoogleCharts } from "google-charts";

export default {
  name: "MapChart",
  props: {
    text: {
      type: String,
      default: "hello world",
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    GoogleCharts.load(
      () => {
        const data = GoogleCharts.api.visualization.arrayToDataTable(this.data);

        const options = {
          colorAxis: { colors: ["#e0f3db", "#721cff"] },
          // backgroundColor: "#f8f8f8",
          datalessRegionColor: "#ffffff",
          defaultColor: "#f5f5f5",
          backgroundColor: { fill: "transparent" },
        };

        const chart = new GoogleCharts.api.visualization.GeoChart(
          this.$refs.mapChart
        );
        chart.draw(data, options);
      },
      { packages: ["geochart"] }
    );
  },
};
</script>
